import type { Priority } from "./enums.js";
import { Q } from "./questions.js";

type Scored = "danger" | "impact" | "worsen";
export type PriorityInput = Partial<Record<Scored, string>> | null | undefined;

const score = (a: Partial<Record<Scored, string>>, k: Scored): number =>
  (Q[k].opts as readonly { k: string; s: number }[]).find((o) => o.k === a[k])?.s ?? 0;

/** Prioriteit uit de antwoorden; zelfde regels als `priorityOf` in het prototype. */
export function priorityOf(a: PriorityInput): Priority {
  if (!a) return "P4";
  const total = score(a, "danger") + score(a, "impact") + score(a, "worsen");
  if (a.danger === "ja" || total >= 6) return "P1";
  if (total >= 4) return "P2";
  if (total >= 2) return "P3";
  return "P4";
}
